import { useEffect, useRef, useState } from "react";
import { Barcode as BarcodeIcon } from "@phosphor-icons/react";
import BarcodeCameraButton from "@/components/BarcodeCameraButton";

/**
 * Barra do leitor de código de barras compartilhada (Kanban + Painel Fábrica).
 * Quando a barra original sai da tela (rolagem), uma cópia flutuante fixa
 * aparece no topo — o leitor fica sempre acessível.
 */
export default function ScannerBar({ value, onChange, onScan, onCameraResult, testidPrefix = "scanner", className = "" }) {
  const anchorRef = useRef(null);
  const [floating, setFloating] = useState(false);

  useEffect(() => {
    const el = anchorRef.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const obs = new IntersectionObserver(([entry]) => setFloating(!entry.isIntersecting));
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const renderBar = (isFloat) => (
    <div
      className={`border border-black bg-yellow-50 px-3 py-1.5 flex items-center gap-2 ${isFloat ? "shadow-xl" : ""}`}
      data-testid={isFloat ? `${testidPrefix}-scanner-bar-floating` : `${testidPrefix}-scanner-bar`}
    >
      <BarcodeIcon size={16} weight="bold" />
      <div className="overline text-[9px] text-zinc-600 whitespace-nowrap">LEITOR</div>
      <input
        className="flex-1 bg-transparent border-none outline-none font-mono text-sm font-bold py-0 min-w-0"
        placeholder="Escaneie o código do pedido..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); onScan(); } }}
        data-testid={isFloat ? `${testidPrefix}-scanner-input-floating` : `${testidPrefix}-scanner-input`}
        autoFocus={!isFloat}
      />
      <BarcodeCameraButton onResult={onCameraResult} />
      {value && (
        <button onClick={onScan} className="btn !py-1 !px-3 text-[10px]" data-testid={isFloat ? `${testidPrefix}-scanner-submit-floating` : `${testidPrefix}-scanner-submit`}>
          Localizar
        </button>
      )}
    </div>
  );

  return (
    <>
      <div ref={anchorRef} className={className}>{renderBar(false)}</div>
      {floating && (
        <div className="fixed top-2 right-2 left-2 md:left-auto md:w-[26rem] z-40">{renderBar(true)}</div>
      )}
    </>
  );
}
